/**
 * Recursively applies a transformation to an entity and all its children
 *
 * @param  {Object} data - data to transform
 * @param  {function} transform - transformation function
 * @param  {string} [childrenKey] - key for the array of children
 * @param  {function} [transformChild] - callback for the child data mapper
 * @return {Object} transformed data
 */
export default function walkNestedData(data, transform, transformChild = null, childrenKey = 'children') {
    const childMapper =
        typeof transformChild === 'function'
            ? transformChild
            : (childData) => walkNestedData(childData, transform, childMapper, childrenKey);
    const transformedData = transform(data);
    if (Array.isArray(transformedData[childrenKey])) {
        transformedData[childrenKey] = transformedData[childrenKey].map(childMapper);
    }
    return transformedData;
}
